import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "message", "confirmButton", "form"]
  static values = {
    title: String,
    message: String,
    confirmText: String,
    confirmClass: String,
    action: String,
    method: String
  }

  connect() {
    // Close modal on escape key
    this.escapeHandler = (e) => {
      if (e.key === "Escape") {
        this.close()
      }
    }
    document.addEventListener("keydown", this.escapeHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.escapeHandler)
  }

  open(event) {
    event.preventDefault()

    const button = event.currentTarget

    // Get data from the button
    const title = button.dataset.confirmTitle || "Confirmar ação"
    const message = button.dataset.confirmMessage || "Tem certeza que deseja continuar?"
    const confirmText = button.dataset.confirmText || "Confirmar"
    const confirmClass = button.dataset.confirmClass || "bg-red-600 hover:bg-red-700"
    const action = button.dataset.confirmAction || button.closest("form")?.action
    const method = button.dataset.confirmMethod || button.closest("form")?.querySelector('[name="_method"]')?.value || "post"

    // Set modal content
    this.titleTarget.textContent = title
    this.messageTarget.textContent = message
    this.confirmButtonTarget.textContent = confirmText
    this.confirmButtonTarget.className = `w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 ${confirmClass} text-white font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2`

    // Store action data
    this.actionValue = action
    this.methodValue = method

    // Show modal with animation
    this.modalTarget.classList.remove("hidden")
    setTimeout(() => {
      this.modalTarget.classList.add("opacity-100")
      this.modalTarget.querySelector(".transform").classList.remove("scale-95")
      this.modalTarget.querySelector(".transform").classList.add("scale-100")
    }, 10)
  }

  close() {
    // Hide modal with animation
    this.modalTarget.classList.remove("opacity-100")
    this.modalTarget.querySelector(".transform").classList.remove("scale-100")
    this.modalTarget.querySelector(".transform").classList.add("scale-95")

    setTimeout(() => {
      this.modalTarget.classList.add("hidden")
    }, 200)
  }

  confirm() {
    // Create and submit a form
    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.actionValue

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement("input")
      csrfInput.type = "hidden"
      csrfInput.name = "authenticity_token"
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    // Add method override if needed
    if (this.methodValue && this.methodValue.toLowerCase() !== "post") {
      const methodInput = document.createElement("input")
      methodInput.type = "hidden"
      methodInput.name = "_method"
      methodInput.value = this.methodValue
      form.appendChild(methodInput)
    }

    // Add to page and submit
    document.body.appendChild(form)
    form.submit()

    this.close()
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }
}
